export const FILE = "1";
export const PROPERTIES = "2";
export const RESULTS = "3";
export const CROWN = "4";
export const LOCATE = "5";
export const ASSET_SEARCH = "6";
